export const SESSION_STORAGE = {
	STATE: "state",
};

export const defaultMarketPlace = "credix-marketplace";

export const NON_MARKET_PLACE_ROUTES = ["help", "credix-pass"];

// TODO: turn into enum
export const SEEDS = {
	DEAL_INFO: "deal-info",
	CREDIX_PASS: "credix-pass",
	BORROWER_INFO: "borrower-info",
};

export const DECIMALS = 6;
